export default{childMarginX:"NONE",childMarginY:"XS"};
